<template>
        <div class="main">
            <a-spin :spinning="spinning">

            <div class="title">
                <div style="position: absolute">
                    <h2>微信列表</h2>
                </div>
<!--                <div class="area-select">-->
<!--                    请选择区域：-->
<!--                    <a-select style="width: 220px"  @change="areaChange">-->
<!--                        <a-select-option :value="item.id" v-for="(item,index) in areaLists" :key="index">{{ item.area }}</a-select-option>-->
<!--                    </a-select>-->
<!--                </div>-->
            </div>
            <div>
                <div class="wx-lists">
                    <a-card-grid class="card-grid" v-for="(item,index) in wxLists" :key="index" @click="goWxList(item)">
                        <img :src="'http://yq.ycydt.cn/'+item.img">
                        <a-card-meta :title="item.wxname" style="text-align: center;line-height: 40px;height: 40px;">
                            <!--<template slot="description">{{ item.unitname }}</template>-->
                        </a-card-meta>
                    </a-card-grid>
                    <!--<a-card-grid class="card-grid" >-->
                        <a-button type="dashed" style="width: 170px;height: 170px;margin: 5px" icon="plus" @click="loadMore()" v-if="!loadAll">加载更多</a-button>
                    <!--</a-card-grid>-->
                </div>
            </div>
            </a-spin>
        </div>

</template>

<script>
    export default {
        name: "Wx",
        data(){
          return{
              areaLists:[],
              wxLists:[],
              param:{aid:0,page:1},
              spinning: false,
              loadAll: false,
              areaid: 0
          }
        },
        created(){
            let siteInfo = JSON.parse(window.localStorage.getItem('siteinfo'))
            this.areaid = siteInfo.area_id
          this.getArea()
        },
        methods:{
            goWxList(item){
                this.$router.push('/Main/Data/Wechat/WxList?id=' + item.BizId)
                // console.log(JSON.stringify(item))
            },
            loadMore(){
                this.param.page ++
                this.getWxLists()
            },
            getWxLists(){
                this.$http.post('http://yq.ycydt.cn/index.php/api/wxNickList',this.param)
                    .then(res=>{
                        if (res.data.state == 200) {
                            for (let i in res.data.data ){
                                this.wxLists.push(res.data.data[i]);
                            }
                            if (res.data.data.length<20) this.loadAll = true
                            this.spinning = false
                            // if (this.param.aid == 0) this.param.aid = res.data.data[0].id
                            // this.areaLists = res.data.data
                        }
                    })
            },
            areaChange(d){
                this.spinning = true
                this.wxLists = []
                this.param.aid = d
                this.loadAll = false
                this.getWxLists()
            },
            getArea(){
                this.spinning = true
                this.$http.get('http://yq.ycydt.cn/index.php/api/area')
                  .then(res=>{
                      if (res.data.state == 200) {
                          for (let i in res.data.data){
                              if (res.data.data[i].ucid == this.areaid){
                                  this.areaChange(res.data.data[i].id)
                              }
                          }
                          // if (this.param.aid == 0) this.param.aid = res.data.data[0].id
                          // this.areaChange(this.param.aid)
                          // this.areaLists = res.data.data
                      }
                  })
            },
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        /*padding-top:10px*/
    }

    .title {
        height:60px;
        line-height: 60px;
        border: 1px solid #e3e3e3;
        padding: 0 20px;
        margin-bottom: 10px;
    }

    .title .area-select{
        position: absolute;
        right: 20px;
    }
    .wx-lists {
        padding: 0 20px;
    }

    .wx-lists img{
        width: 120px;
        height: 120px;
    }

    .wx-lists .card-grid {
        width:170px;
        padding:10px 25px;
        textAlign:'center';
        margin: 5px;
        cursor: pointer;
    }
</style>
